import React, { useState, useEffect } from "react";
import Auth from "@aws-amplify/auth";
import GenericInput from "../containers/helpers/genericInput";
import { useFormFields } from "../libs/hooksLibs";
import styles from "../styles/Signup.module.scss";
import LoaderButton from "./LoaderButton";
import Log from "../utils/Log";
import classnames from "classnames";
import { scrollToLogin } from "../utils/scrollAnimations";
import { useDispatch } from "react-redux";
import { clientLoginRedirect } from "../actions/current";

//confirmation code input used during sign up process

export default function ConfirmationCode(props) {
  const dispatch = useDispatch();
  const [confirmationErrorText, setConfirmationError] = useState(
    "Thank you for signing up. Please check your email for a code to verify your account."
  );
  const [isLoading, setIsLoading] = useState(false);
  const [userInfo, setUserInfo] = useState(null);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const { fromBBClient } = props;

  useEffect(() => {
    const handleWindowResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  });

  useEffect(() => {
    if (!props.username && props.confirmationData) {
      const { username, password } = props.confirmationData;
      setUserInfo({
        username: username,
        password: password,
      });
    } else {
      setUserInfo({
        username: props.username,
        password: props.password,
      });
    }
    //eslint-disable-next-line
  }, [props.confirmationData]);

  const firstInputTabRef = React.createRef();

  const resetTab = () => {
    firstInputTabRef.current.focus();
  };

  const inputStyles = {
    container: styles.signupContainer,
    label: styles.signupInputLabel,
    input: styles.signupInput,
    error: styles.signupInputError,
  };

  const [fields, updateField] = useFormFields({
    confirmationCode: "",
  });

  const [errorStateObject, updateInputErrorState] = useFormFields({
    confirmPassword: false,
  });

  function validateConfirmationForm() {
    return fields.confirmationCode.length > 0;
  }

  function handleFieldChange(inputName, value) {
    if (validateConfirmationForm(value)) {
      updateInputErrorState(inputName, false);
    }
    setConfirmationError(
      "Thank you for signing up. Please check your email for a code to verify your account."
    );
    updateField(inputName, value);
  }

  async function handleSubmit(event) {
    event.preventDefault();

    if (!validateConfirmationForm()) {
      setConfirmationError("Please fill out the required field");
      updateInputErrorState("confirmationCode", true);
      return;
    }

    setIsLoading(true);

    try {
      await Auth.confirmSignUp(userInfo.username, fields.confirmationCode);

      if (fromBBClient) {
        await dispatch(
          clientLoginRedirect(userInfo.username, userInfo.password)
        );
      } else {
        await Auth.signIn(userInfo.username, userInfo.password);
      }
    } catch (e) {
      setConfirmationError(e.message);
      setIsLoading(false);
    }

    return Log.info("confirmation code submitted!");
  }

  async function resendVerificationCode() {
    try {
      await Auth.resendSignUp(userInfo.username);
      setConfirmationError(
        "A new code has been sent. Please check your email for the code or click the link to activate your account."
      );
      Log.trace("code resent succesfully");
    } catch (err) {
      Log.error("error resending code: ", err);
    }
  }

  function renderResendCodeLink() {
    return (
      <div className={styles.resendCodeWrapper}>
        <span
          className={classnames(styles.clientLoginText, styles.link)}
          onClick={resendVerificationCode}
        >
          Resend Code
        </span>
      </div>
    );
  }

  function renderConfirmationForm() {
    return (
      <form className={styles.form} onSubmit={handleSubmit}>
        <GenericInput
          type={"text"}
          placeholder={"XXXXXX"}
          inputName={"confirmationCode"}
          inputValue={fields.confirmationCode}
          changeCallback={handleFieldChange}
          styles={inputStyles}
          errorState={errorStateObject.confirmationCode}
          ref={firstInputTabRef}
        />

        {renderResendCodeLink()}

        <LoaderButton
          type="submit"
          isLoading={isLoading}
          onClick={handleSubmit}
          onBlurCallback={resetTab}
        >
          {" "}
          Verify
        </LoaderButton>
      </form>
    );
  }

  return (
    <div id={"confirmationcode"}>
      <div className={styles.confirmationFormClient}>
        {!props.referral && (
          <span
            className={classnames(styles.clientLoginText, styles.link)}
            onClick={() => scrollToLogin(props, windowWidth)}
          >
            <img
              className={styles.arrow}
              src={"https://frontend-assets.buildbox.com/Arrow+Up.svg"}
              alt="Return to sign in"
            />
            Return to Sign in
          </span>
        )}
        <div className={styles.passwordRequirement}>
          {confirmationErrorText}
        </div>
      </div>
      {renderConfirmationForm()}
    </div>
  );
}
